import React from 'react';
import { RouteData, withSiteData } from 'react-static';
//
import Navigation from 'components/navigation';
//
export default withSiteData(props => (
  <RouteData>
    {({ microsite, site }) => (
      <Navigation menu={props[site]} microsite={microsite} />
    )}
  </RouteData>
));
